let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("g813d")).then(() => parcelRequire('hLNj0'));